/* eslint-disable camelcase */
const fullYear = 'YYYY'
const partialYear = 'YY'
const fullMonth = 'MMMM'
const abbreviatedMonth = 'MMM'
const monthNumber = 'MM'
const dayNumber = 'DD'
const dayName = 'dddd'
const abbreviatedDayName = 'ddd'

const monthAndDay = `${abbreviatedMonth} Do`
const monthAndDayWithYear = `${monthAndDay}, ${fullYear}`
const dayNameWithMonthAndDayWithYear = `${dayName}, ${monthAndDayWithYear}`
const timeWithAMPM = 'h:mm A'
const hours = 'hh'
const minutes = 'mm'

const airtableDateFormat = `${monthNumber}/${dayNumber}/${fullYear}`

export const TIME_FORMATS = {
  // Generic
  timeWithAMPM,
  timeWithAMPMAndZone: `${timeWithAMPM} z`,
  monthAndDay,
  monthAndDayWithYear,
  dayNameWithMonthAndDayWithYear,
  fullYear,
  partialYear,
  // Calendar
  calendarDate: `${fullYear}-${monthNumber}-${dayNumber}`,
  calendarCurrentMonthSoldOut: abbreviatedMonth,
  calendarCurrentMonth: fullMonth,
  calendarSelectedDate: `${dayName}, ${fullMonth} D`,
  dayTile: 'dddd, MMM Do',
  calendarMetaDate: `${monthNumber}/${dayNumber}/${fullYear} ${hours}:${minutes}`,
  /* Sticky Footer Left Aside */
  stickyFooterDate: `${monthNumber}/${dayNumber}`,
  // Timeslots
  hoursAndMinutes: 'HH:mm',
  openHoursDate: `${fullMonth} Do`,
  timeslotTestId: `${fullYear}-${dayNumber}-${monthNumber} ${timeWithAMPM}`,
  // Selected date collapsed
  selectedDate: `${dayName}, ${fullMonth} D, ${fullYear}`,
  // OrderItem
  onSaleDate: `${abbreviatedDayName}, ${monthAndDay} @ ${timeWithAMPM}`,
  onSaleDateWithZone: `${abbreviatedDayName}, ${monthAndDay} @ ${timeWithAMPM} z`,
  // Event card single timeslot
  eventCardShortMonthDayNumber: `${abbreviatedMonth} ${dayNumber}, ${fullYear}`,
  eventCardStart_single: `${monthAndDay} [Doors] @ ${timeWithAMPM}`,
  eventCardStartWithYear_single: `${abbreviatedMonth} ${dayNumber}, ${fullYear} [Doors] @ ${timeWithAMPM}`,
  // Event card multiple timeslots
  eventCardStart_multiple: `${monthAndDay}`,
  eventCardEnd_multiple: monthAndDay,
  eventCardEndWithYear_multiple: `${monthAndDay}, ${fullYear}`,
  airtableDateFormat,
  schemaFormat: `${fullYear}-${monthNumber}-${dayNumber}THH:mm:ssZZ`,
}

export const UTC_FORMAT = 'YYYY-MM-DDTHH:mm'
